var Dropdown = function (config) {
  jsGrid.Field.call(this, config);
};

Dropdown.prototype = new jsGrid.Field({
  css: "dropdown-dclg", // redefine general property 'css'

  itemTemplate: function (dropdownItems, row) {
    if (
      !(
        dropdownItems &&
        Object.prototype.toString.call(dropdownItems) === "[object Array]"
      )
    ) {
      return "";
    }

    var $dataGrid = $(this._grid._container);

    // 1. Generate unique ID for linking button and menu list
    var uniqueId = "dropdown-list-" + Math.floor(Math.random() * 1000000);


    var $cell = $('<div class="js-dropdown-list-wrapper"></div>');
    var $trigger = $(
        '<button type="button" aria-haspopup="true" aria-expanded="false" aria-controls="' +
        uniqueId +
        '">More <i class="fa fa-caret-down" aria-hidden="true"></i></button>',
    );
    var $list = $(
        '<ul id="' +
        uniqueId +
        '" class="js-dropdown-list js-dropdown-list-closed" aria-hidden="true"></ul>',
    );

    function _setDropdownState(isOpen) {
      $trigger.data("open", isOpen);
      $trigger.attr("aria-expanded", isOpen ? "true" : "false");
      $list.attr("aria-hidden", isOpen ? "false" : "true");
      if (isOpen) {
        $list.removeClass("js-dropdown-list-closed");
      } else {
        $list.addClass("js-dropdown-list-closed");
      }
    }

    dropdownItems.forEach(function (item) {
      var $link;
      if (item.content == "Start review for specific dates") {
        $link = $(
          '<a class="start-transaction-review" href="' +
            item.url +
            '">' +
            item.content +
            "</a>",
        );
      } else {
        $link = $('<a href="' + item.url + '">' + item.content + "</a>");
      }
      var $listItem = $('<li class="js-dropdown-list-item"></li>');

      // If there are class names defined that need to be initialised on the 'delete' element,
      // for example, that responsible for opening a dialog box.
      if (!!item.classlist) {
        // Current defined as '2' for these properties:
        // 1. name
        // 2. data
        var MIN_LEN_FOR_CLASSLIST_ITEM_DEFINED_AS_OBJECT = 2;

        $.each(item.classlist, function (_, classname) {
          if ($.isPlainObject(classname)) {
            // Processing the data received from the backend
            if (
              Object.keys(classname).length >=
              MIN_LEN_FOR_CLASSLIST_ITEM_DEFINED_AS_OBJECT
            ) {
              var key;
              for (key in classname) {
                if (classname.hasOwnProperty(key)) {
                  // Add processed data to our application
                  switch (key) {
                    case "name":
                      $listItem.addClass(classname[key]);
                      break;
                    case "data":
                      var attribValue;
                      $.each(
                        Object.keys(classname[key]),
                        function (index, dataAttrib) {
                          attribValue = classname[key][dataAttrib];
                          $listItem.attr("data-" + dataAttrib, attribValue);
                        },
                      );
                      break;
                    default:
                      throw new Error(
                        "The classlist item provided here is currently unaccounted for",
                      );
                      break;
                  }
                }
              }
            } else {
              throw new Error(
                'The "classlist" item you defined as an Object does not conform to current code logic',
              );
            }
          } else {
            $listItem.addClass(classname);
          }
        });
      }

      if (item.type === "delete") {
        // Binding delete action to click event
        $link.on("click", function (event) {
          event.preventDefault();
          $listItem.trigger("dialog.type.delete", {
            table: $dataGrid,
            row: row,
          });
        });
      }

      $list.append($listItem.append($link));
    });
    $list.find("li:last").bind("focusout", function () {
      _setDropdownState(false);
    });

    // For handling clicking anywhere on the page, when the dropdown is open
    $("body").bind("click.dclgGridDropdown", closeOpenDropdownEvent);

    $dataGrid.on("dclg.dataGrid.pageChange", function () {
      $("body").unbind("click.dclgGridDropdown", closeOpenDropdownEvent);
    });

    function closeOpenDropdownEvent(event) {
      // console.log('dclgGridDropdown', event);
      if (
        event.target !== $trigger.get(0) &&
        event.target !== $trigger.children("i").get(0)
      ) {
        _setDropdownState(false);
        reviewDropdownPosition($list, $dataGrid.closest(".grid-wrapper"));
      }
    }

    function isInCollectionRequestPage() {
      return $("#collection-request-page").length > 0;
    }

    function isInDatastorePage() {
      return $("#datastore-page").length > 0;
    }

    function isInUserListPage() {
      return $("#userslist-page").length > 0;
    }

    function reviewDropdownPosition($dropdown, $container) {
      var off = $dropdown.offset();
      var h = $dropdown.height();
      var w = $dropdown.width();

      var OFF = $container.offset();
      var H = $container.height();
      var W = $container.width();

      if (off.top + h > OFF.top + H) {
        $dropdown.addClass("overflown");
      } else {
        $dropdown.removeClass("overflown");
      }
    }

    // Finishing off definition for dropdown...
    $trigger.data("open", false).on("click", function () {
      var isCurrentlyOpen = $(this).data("open");
      _setDropdownState(!isCurrentlyOpen);

      reviewDropdownPosition(
        $list,
        $dataGrid.closest(".js-sliding-panel-wrapper"),
      );
    });

    $cell.append($trigger).append($list);

    // If there are no dropdown items, return nothing...
    return $cell.find("li").length ? $cell : "";
  },
});

module.exports = Dropdown;
